import { getRequest } from '../clients/axios';
import type { PlayerModelGroup } from '../models/PlayerModels';

export const getPlayerModels = async (playerId: number): Promise<PlayerModelGroup[]> => {
  const response = await getRequest(`orders/players/${playerId}/models`);
  return response.data;
};
